module.exports = __webpack_public_path__ + "static/jason1-6463e30b247b1c1fa97db2e90614deea.jpg";